import { ReadingLevelFilters } from "@tlc/ls2pac/components/BooleanSearchForm";
import { SearchSortType } from "../lists/SavedListSortControl";
import {
  ResourceListOwnerType,
  ResourceListScope,
  ResourceListSortType,
} from "../ListService";
import axios from "axios";
import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { FacetFilter } from "../../../../dto/FacetFilter";

interface DynamicResourceListParameters {
  name: string;
  scope: ResourceListScope;
  ownerType?: ResourceListOwnerType;
  expression: string;
  sortType: SearchSortType;
  facetFilters: FacetFilter[];
  branchFilters: string[];
  readingLevelFilters: ReadingLevelFilters;
}

export interface SaveSearchParams
  extends Omit<DynamicResourceListParameters, "scope" | "ownerType"> {}

export interface DynamiResourceListView {
  id: number;
  creatorName: string;
  ownerType: ResourceListOwnerType;
  ownerId: number;
  scope: ResourceListScope;
  name: string;
  caption: string;
  creationDate: string; // Date
  lastUpdateDate: string; // Date
  lastFeedRetrievalDate: string; // Date
  advanced: boolean;
  expression: string;
  sortType: SearchSortType;
  facetFilters: FacetFilter[];
  branchFilters: string[];
  readingLevelFilters: ReadingLevelFilters;
  url: string; // external resource list fields
}

export const SavedSearchesService = (() => {
  class SavedSearchesHolder {
    public async saveSearch(params: SaveSearchParams, isConfig: boolean) {
      const url = isConfig ? `/list/dynamic/config` : `/list/dynamic`;
      const { data } = await axios.post<DynamiResourceListView>(url, {
        ...params,
        scope: isConfig ? ResourceListScope.Public : ResourceListScope.Private,
      });
      AccountHolder.fetchAccountSummaryAndPatron(true); // trigger refresh of counts
      return data;
    }

    public async getSearches(
      isConfig: boolean,
      page: number,
      pageSize: number,
      sortType: ResourceListSortType
    ) {
      const firstResult = page * pageSize;
      if (isConfig) {
        const { data } = await axios.get<DynamiResourceListView[]>(
          `/lists/dynamic/config/${firstResult}/${pageSize}/${sortType}`
        );
        return data;
      }
      const { data } = await axios.get<DynamiResourceListView[]>(
        `lists/dynamic/${firstResult}/${pageSize}/${sortType}`
      );
      return data;
    }
  }

  return new SavedSearchesHolder();
})();
